import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../localstorage.service';

export interface InsuranceData {
  preencherValorDeclarado?: boolean;
  preencherTodosEnvios?: boolean;
  valorMinimoDeclarado?: number;
}

export interface DePara {
  id?: number;
  de: string;
  para: string;
}

export interface ShippingOptionsMapping {
  [shippingOption: string]: DePara[];
}

@Injectable()
export class IntegrationApiService {
  constructor(private http: HttpClient, private localStorageService: LocalStorageService) { }

  public getOrderStatus(provider: string) {
    if (!provider) {
      return throwError(new Error('Provider not set'));
    }

    return this.http.get(`${environment.angularJSconstants.PUBLIC_API}/plataformas/${provider}/mapeamentos/status-pedido`,
    this.makePrivateOptions());
  }

  public setOrderStatus(provider: string, status: any) {
    if (!provider) {
      return throwError(new Error('Provider not set'));
    }

    return this.http.post(`${environment.angularJSconstants.PUBLIC_API}/plataformas/${provider}/mapeamentos/status-pedido`, { status },
    this.makePrivateOptions());
  }

  public getAutomaticShippingMapping(provider: string) {
    if (!provider) {
      return throwError(new Error('Provider not set'));
    }

    return this.http.get<ShippingOptionsMapping>(
      `${environment.angularJSconstants.PUBLIC_API}/plataformas/${provider}/mapeamentos/de-para`, this.makePrivateOptions());
  }

  public addAutomaticShippingMapping(provider: string, mappings: DePara[]) {
    if (!provider) {
      return throwError(new Error('Provider not set'));
    }

    return this.http.post(
      `${environment.angularJSconstants.PUBLIC_API}/plataformas/${provider}/mapeamentos/de-para`,
      { dePara: mappings },
      this.makePrivateOptions()
    );
  }

  public deleteAutomaticShippingMapping(provider: string, mappings: number[]) {
    if (!provider) {
      return throwError(new Error('Provider not set'));
    }

    return this.http.post(`${environment.angularJSconstants.PUBLIC_API}/plataformas/${provider}/mapeamentos/de-para/remover`, {
      ids: mappings,
    },
    this.makePrivateOptions());
  }

  public getAutomaticInsurance(provider: string) {
    if (!provider) {
      return throwError(new Error('Provider not set'));
    }

    return this.http.get(`${environment.angularJSconstants.PUBLIC_API}/plataformas/${provider}/mapeamentos/preenche-valor-declarado`,
    this.makePrivateOptions());
  }

  public setAutomaticInsurance(provider: string, insuranceData: InsuranceData) {
    if (!provider) {
      return throwError(new Error('Provider not set'));
    }

    return this.http.post(
      `${environment.angularJSconstants.PUBLIC_API}/plataformas/${provider}/mapeamentos/preenche-valor-declarado`,
      insuranceData,
      this.makePrivateOptions()
    );
  }

  private makePrivateOptions() {
    return {
      headers: {
        Authorization: this.localStorageService.get('token'),
      },
    };
  }
}
